import React from 'react';
import { node } from 'prop-types';
import usePersistState from '@hooks/usePersistState';


export const KycEddContext = React.createContext();

const KycEddProvider = ({ children }) => {

  const [collectEddValues, setCollectEddValues] = usePersistState('kyc_collectEddValues', {});
  
  const onDoCollectEddValues = (values) => {
    setCollectEddValues({...collectEddValues, ...values});
  };

  const resetEddValues = () => {
    setCollectEddValues({});
  }

  const valueProps = {
    collectEddValues, 
    setCollectEddValues,
    onDoCollectEddValues,
    resetEddValues
  };

  return (
    <KycEddContext.Provider value={valueProps}>
      {children}
    </KycEddContext.Provider>
  );
}


KycEddProvider.propTypes = {
  children: node.isRequired,
};

export default KycEddProvider;